import {
  getApi,
  getApiErrorAdmin,
  postApi,
  postApiErrorAdmin,
} from "../utils/common";

export const getAdmin = async (searchCondition) => {
  const urlPath = "/api/admin/adminuser/list/?";
  const searchParams = new URLSearchParams(searchCondition);
  try {
    // const res = await fetch(url, {
    //   mode: "cors", //クロスオリジンリクエストをするのでCORSモードにする
    //   credentials: "include", //クレデンシャルを含める指定
    // });
    // const json = await res.json();
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

//管理者新規登録
export const postAddAdmin = async (data) => {
  const urlPath = "/api/admin/adminuser/add/?";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 管理ユーザー-パスワード確認
export const postIsValidPassword = async (id, data) => {
  const urlPath = "/api/admin/adminuser/password/";
  const postData = { id: id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

//管理ユーザー変更
export const postUpdateAdmin = async (id, data) => {
  const urlPath = "/api/admin/adminuser/update/?";
  const postData = { id: id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 管理画面-管理者ユーザー取得
export const getAdminUser = async (id) => {
  const urlPath = "/api/admin/adminuser/detail/?";
  const searchParams = new URLSearchParams({ id: id });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};
